/* ============================================================
   Ancres de rangée — page article podcast
   Fichier : claude-podcast-anchors.js

   Le sommaire pointe vers `…/mon-episode#description` et `…#transcript`.
   Arriver sur l'ancre doit ouvrir la rangée visée, pas seulement défiler
   jusqu'à un accordéon fermé.

   L'ouverture se fait en posant `details.open`, exactement ce que fait la
   méthode open() de <accordion-tab> (global.js) : son onClick relit
   `details.open` à chaque clic, l'état reste donc cohérent et l'accordéon
   se referme normalement ensuite. On ne touche pas à son animation.
   ============================================================ */

(function () {
  function reveal() {
    var id = window.location.hash.slice(1);
    if (!id) return;

    var target = document.getElementById(id);
    if (!target) return;

    // La rangée peut être un <details> (mode repliable) ou un simple bloc
    // (mode déplié) : dans le second cas il n'y a rien à ouvrir.
    var details = target.matches('details') ? target : target.querySelector('details');
    if (details && !details.open) details.open = true;

    var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: motionOk ? 'smooth' : 'auto', block: 'start' });
    });
  }

  window.addEventListener('hashchange', reveal);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
